import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CourseOfStudyActions from './courseofstudy.actions';
import { CourseOfStudyService } from '../../services/courseofstudy.service';

@Injectable()
export class CourseOfStudyEffects {
  loadCourseOfStudy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CourseOfStudyActions.loadCourseOfStudy),
      exhaustMap((_) =>
        this.courseofstudyService.getCourseOfStudy().pipe(
          map((data) =>
            CourseOfStudyActions.loadCourseOfStudySuccess({
              courseofstudy: data,
            })
          ),
          catchError((error) =>
            of(CourseOfStudyActions.loadCourseOfStudyFailure({ error }))
          )
        )
      )
    )
  );

  addCourseOfStudy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CourseOfStudyActions.addCourseOfStudy),
      concatMap(({ newCourseOfStudy }) =>
        this.courseofstudyService.createCourseOfStudy(newCourseOfStudy).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return CourseOfStudyActions.addCourseOfStudySuccess({
              newCourseOfStudy: data,
            });
          }),
          catchError((error) =>
            of(
              CourseOfStudyActions.addCourseOfStudyFailure({
                error: error.error.message,
              })
            )
          )
        )
      )
    )
  );

  updateCourseOfStudy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CourseOfStudyActions.updateCourseOfStudy),
      map((action) => action.updateCourseOfStudy),
      concatMap((updateCourseOfStudy) =>
        this.courseofstudyService.updateCourseOfStudy(updateCourseOfStudy).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return CourseOfStudyActions.updateCourseOfStudySuccess({
              updateCourseOfStudy: updateCourseOfStudy,
            });
          }),
          catchError((error) =>
            of(
              CourseOfStudyActions.updateCourseOfStudyFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  removeCourseOfStudy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CourseOfStudyActions.removeCourseOfStudy),
      map((action) => action.ids),
      concatMap((ids) =>
        this.courseofstudyService.deleteCourseOfStudy(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return CourseOfStudyActions.removeCourseOfStudySuccess({ ids });
          }),
          catchError((error) =>
            of(
              CourseOfStudyActions.updateCourseOfStudyFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private courseofstudyService: CourseOfStudyService,
    private notification: NotificationService
  ) {}
}
